import {Component, OnDestroy, OnInit} from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import {UtilConfig} from '../../autenticacion/servicios/UtilConfig';
import {ActivatedRoute, Router} from '@angular/router';
import {LayoutService} from '../recursos/servicio/layout.service';
import {Subscription} from 'rxjs/Subscription';

declare const $: any;

export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    authorities: string[];
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
    visible?: boolean;
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    icontype: string;
    authorities: string[];
    type?: string;
    visible?: boolean;
}


export let ROUTES: RouteInfo[] = [
    {
        path: 'home',
        title: 'Home',
        type: 'link',
        visible: true,
        icontype: 'home',
        authorities: ['ROLE_INICIAR_SESION']

    }, {
        path: 'seguridad',
        title: 'Seguridad',
        type: 'sub',
        visible: true,
        authorities: ['ROLE_USUARIO_LISTAR', 'ROLE_CUSTOMER_LISTAR'],
        icontype: 'security',
        collapse: 'content_seguridad',
        children: [
            {path: 'emisor', title: 'Emisor', ab: 'E', icontype: 'business', authorities: ['ROLE_CUSTOMER_LISTAR']},
            {
                path: 'usuario',
                title: 'Usuarios',
                ab: 'U',
                visible: true,
                icontype: 'account_box',
                authorities: ['ROLE_USUARIO_LISTAR']
            },
            {
                path: 'roles',
                visible: true,
                title: 'Roles',
                ab: 'U',
                icontype: 'bookmark',
                authorities: ['ROLE_ROL_LISTAR']
            },
            /*{
                path: 'auditoria',
                visible: true,
                title: 'Auditoría',
                ab: 'A',
                icontype: 'bookmark',
                authorities: ['ROLE_ROL_LISTAR']
            },*/
            {
                path: 'configuracion/create',
                title: 'Configuración',
                visible: true,
                ab: 'C',
                icontype: 'settings',
                authorities: ['ROLE_CONFIGURATION_SECURITY_REGISTRAR']
            }
        ]
    },
    {
        path: 'facturador',
        title: 'Crear comprobante',
        type: 'link',
        icontype: 'receipt',
        visible: true,
        authorities: ['ROLE_FACTURADOR_INVOICE',
            'ROLE_FACTURADOR_TICKET',
            'ROLE_FACTURADOR_NC',
            'ROLE_FACTURADOR_ND',
            'ROLE_FACTURADOR_GRE',
            'ROLE_FACTURADOR_ANULACIONES',
            'ROLE_FACTURADOR_RETENCIONES'
        ]
    }, {
        path: 'registroVentas',
        title: 'Registro de ventas',
        type: 'link',
        icontype: 'attach_money',
        visible: false,
        authorities: []
    },
    {
        path: 'documentos',
        title: 'Documentos',
        type: 'sub',
        visible: true,
        authorities: ['ROLE_LOG_SUNAT_LISTAR', 'ROLE_LOG_LISTAR', 'ROLE_LOG_RECIBIDOS_LISTAR'],
        icontype: 'description',
        collapse: 'content_documentos',
        children: [
            {
                path: 'logEmisor',
                title: 'Generados',
                ab: 'E',
                visible: true,
                icontype: 'send',
                authorities: ['ROLE_LOG_LISTAR']
            }, {
                path: 'logEmisorHistory',
                title: 'Historicos',
                ab: 'H',
                visible: true,
                icontype: 'send',
                authorities: ['ROLE_LOG_LISTAR']
            }, {
                path: 'Recibidos',
                title: 'Recibidos',
                ab: 'E',
                visible: true,
                icontype: 'markunread_mailbox',
                authorities: ['ROLE_LOG_RECIBIDOS_LISTAR']
            },{
                path: 'logSFTP',
                title: 'SFTP',
                ab: 'S',
                visible: true,
                icontype: 'markunread_mailbox',
                authorities: ['ROLE_LOG_RECIBIDOS_LISTAR']
            },
            {
                path: 'logSunat',
                title: 'Envío SUNAT',
                ab: 'ES',
                visible: true,
                icontype: 'assignment_turned_in',
                authorities: ['ROLE_LOG_SUNAT_LISTAR']
            }
            // {
            //     path: 'logNoTransformados',
            //     title: 'Fallidos',
            //     ab: 'CE',
            //     visible: true,
            //     icontype: 'warning',
            //     authorities: ['ROLE_LOG_FALLIDOS_LISTAR']
            // }

        ]
    }, {
        path: 'thirds',
        title: 'Emisión de terceros',
        type: 'sub',
        visible: true,
        authorities: ['ROLE_CONF_TERCERO_LISTAR', 'ROLE_LOTE_TERCERO_LISTAR'],
        icontype: 'widgets',
        collapse: 'content_thirds',
        children: [
            {
                path: 'configThrids',
                title: 'Configuración',
                ab: 'C',
                visible: true,
                icontype: 'settings',
                authorities: ['ROLE_CONF_TERCERO_LISTAR']
            },
            {
                path: 'listDocumentThrids/ELECTRONIC',
                title: 'Documentos Electronicos',
                ab: 'C',
                visible: true,
                icontype: 'markunread_mailbox',
                authorities: ['ROLE_LOTE_TERCERO_LISTAR']
            },
            {
                path: 'listDocumentThrids/PHYSICAL',
                title: 'Documentos físicos',
                ab: 'DF',
                visible: true,
                icontype: 'markunread_mailbox',
                authorities: ['ROLE_LOTE_TERCERO_LISTAR']
            }
        ]
    }, {
        path: 'Analíticos',
        title: 'Analíticos',
        type: 'sub',
        visible: true,
        authorities: ['ROLE_INDICADORES_GENERAL', 'ROLE_REPORTE_LISTAR'],
        icontype: 'trending_up',
        collapse: 'tables',
        children: [
            /*{
                path: 'operativos',
                title: 'Operativos',
                ab: 'O',
                visible: true,
                icontype: 'show_chart',
                authorities: ['ROLE_INDICADORES_GENERAL']
            },*/
            {
                path: 'gestion',
                title: 'Gestión',
                ab: 'G',
                visible: true,
                icontype: 'insert_chart',
                authorities: ['ROLE_INDICADORES_GENERAL']
            },
            {
                path: 'reporte',
                title: 'Reportes',
                visible: true,
                ab: 'R',
                icontype: 'sort',
                authorities: ['ROLE_REPORTE_LISTAR']
            }
        ]
    }
];

@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: './../sidebar/sidebar.component.html',
})


export class SidebarComponent implements OnInit, OnDestroy {
    public menuItems: any[];
    public usuarioSession;
    public expanded = true;
    subscription: Subscription;

    constructor(private router: Router,
                private layoutService: LayoutService,
                private route: ActivatedRoute,
                public util: UtilConfig) {
        this.usuarioSession = this.util.getCurrentUser();
        this.subscription = this.layoutService.getUsuarioSession().subscribe(usuarioSession => {
            this.usuarioSession = usuarioSession;
        });

    }


    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    ngOnInit() {
        let EMISOR_APP = false;
        let THIRDS_APP = false;
        $.each(this.usuarioSession.customer.applications, (pos, item) => {
            if (item === 'EMISOR') {
                EMISOR_APP = true;
            }
            if (item === 'THIRDS') {
                THIRDS_APP = true;
            }

        });
        this.menuItems = ROUTES.filter(menuItem => menuItem);
        $.each(this.menuItems, (pos, item) => {
            if (item.path === 'facturador') {
                item.visible = false;
                if (EMISOR_APP && this.util.hasAuthorities(item.authorities)) {
                    item.visible = true;
                }
            } else if (item.path === 'registroVentas') {
                if (!this.usuarioSession.customer.salesRecord) {
                    item.visible = false;
                }
            } else {
                if (item.path === 'thirds' && this.util.hasAuthorities(item.authorities)) {
                    if (!THIRDS_APP) {
                        item.visible = false;
                    }
                } else {
                    item.visible = this.util.hasAuthorities(item.authorities);
                }
                if (item.visible) {

                    $.each(item.children, (pos2, subItem) => {
                        if (subItem.path === 'facturador' && !EMISOR_APP) {
                            subItem.visible = false;
                        } else if (subItem.path === 'logEmisorHistory') {
                            if (!this.usuarioSession.customer.enabledHistory) {
                                subItem.visible = false;
                            }
                        } else {
                            subItem.visible = this.util.hasAuthorities(subItem.authorities);
                        }

                    });
                }
            }
        });
        console.log(this.menuItems);
        $('.opcionMenu a').click(function () {
            $('.opcionMenu').removeClass('active').removeClass('visible');
            $(this).closest('.opcionMenu').addClass('active').addClass('visible');
        });

    }

    updatePS(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            const ps = new PerfectScrollbar(elemSidebar, {wheelSpeed: 2, suppressScrollX: true});
        }
    }

    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }

    verPerfil() {
        this.router.navigate(['/content', {outlets: {'second': ['detallePerfil']}}]);
    }

    cerrarTodas() {
        $('.collapse.in').closest('li').find('a').click();
    }

    ngToggleSidebar() {
        $('.navbar-toggle').trigger('click');
    }

    toggleSidebar() {
        this.expanded = !this.expanded;
        $('body').addClass('sidebar-mini');
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/sidebar/sidebar.component.ts